import { Separator } from '@repo/shared-client/components/ui'
import { createFileRoute, stripSearchParams, useSearch } from '@tanstack/react-router'
import AdminPointsDistributionChart from '@web/src/features/admin/admin-points/admin-points-distribution-chart'
import AdminPointsLeaderboard from '@web/src/features/admin/admin-points/admin-points-leaderboard'
import AdminPointsSummary from '@web/src/features/admin/admin-points/admin-points-summary'
import AdminPointsTrendChart from '@web/src/features/admin/admin-points/admin-points-trend-chart'
import { env } from '@web/src/lib/env.client'
import { useTranslation } from '@web/src/lib/intl/react'
import { robotsMetaForEnvironment, seo } from '@web/src/lib/seo'
import { z } from 'zod'

export const Route = createFileRoute('/(auth)/(admin-layout)/admin/points')({
  component: PointsPage,
  validateSearch: z.object({
    page: z.number().optional(),
    search: z.string().optional(),
    sortBy: z.string().optional(),
  }),
  search: {
    middlewares: [
      stripSearchParams({
        page: 1,
        search: '',
        sortBy: 'AVAILABLE_DESC',
      }),
    ],
  },
  head: () =>
    seo({
      description: 'Admin Points Monitoring Page',
      robots: robotsMetaForEnvironment({ all: 'noindex,nofollow' }),
      title: `Admin - Points | ${env.VITE_APP_NAME}`,
    }),
})

function PointsPage() {
  const { t } = useTranslation()
  const search = useSearch({ strict: false })

  const page = search.page ? Number.parseInt(String(search.page), 10) : 1
  const searchTerm = search.search || ''
  const sortBy = search.sortBy || 'AVAILABLE_DESC'

  return (
    <div className="mx-auto w-full max-w-screen-xl py-6">
      <h1 className="mb-6 font-semibold text-2xl tracking-tight">{t('Points Program')}</h1>

      <h2 className="mb-4 font-medium text-lg">{t('Program overview')}</h2>
      <AdminPointsSummary />

      <Separator className="my-8 w-full" />

      <h2 className="mb-4 font-medium text-lg">{t('Analytics')}</h2>
      <div className="mb-8 grid grid-cols-1 gap-6 md:grid-cols-2">
        <AdminPointsDistributionChart cardClassName="h-[400px]" />
        <AdminPointsTrendChart cardClassName="h-[400px]" />
      </div>

      <Separator className="my-8 w-full" />

      <h2 className="mb-4 font-medium text-lg">{t('Profile leaderboard')}</h2>
      <AdminPointsLeaderboard page={page} search={searchTerm} sortBy={sortBy} />
    </div>
  )
}
